var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-skeleton h-twentyFive w-twentyFive rounded",class:[_vm.pulseClasses],attrs:{"aria-hidden":"true","data-test":"checkbox"}})
}
var staticRenderFns = []

export { render, staticRenderFns }